import { useQuery } from "@tanstack/react-query";

import { Card, DataTable, PageHeader } from "../components/ui";
import { day, time } from "../lib/format";
import { adminApi } from "./api";
import { actionLabel } from "./helpers";

export function AdminAudit() {
  const audit = useQuery({ queryKey: ["admin", "audit"], queryFn: () => adminApi.audit(200), retry: false });
  const rows = audit.data ?? [];

  return (
    <div className="page">
      <PageHeader title="Audit log">Everything done here, newest first.</PageHeader>

      {audit.error ? (
        <Card>
          <p className="notice notice-crit" role="alert">
            {audit.error.message}
          </p>
        </Card>
      ) : !audit.data ? (
        <Card>
          <p className="tiny muted">Loading…</p>
        </Card>
      ) : rows.length === 0 ? (
        <Card>
          <p className="tiny muted">Nothing yet.</p>
        </Card>
      ) : (
        <>
          <div className="desk-only">
            <Card padded={false}>
              <DataTable
                columns={[
                  { key: "when", label: "When" },
                  { key: "who", label: "Who" },
                  { key: "what", label: "What" },
                  { key: "business", label: "Business" },
                  { key: "detail", label: "Detail" },
                ]}
              >
                {rows.map((r, i) => (
                  <tr key={`${r.at}-${i}`}>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {day(r.at)} {time(r.at)}
                    </td>
                    <td className="adm-wrap">{r.admin_email}</td>
                    <td>{actionLabel(r.action)}</td>
                    <td>{r.business ?? "—"}</td>
                    <td className="adm-wrap">{r.detail ?? "—"}</td>
                  </tr>
                ))}
              </DataTable>
            </Card>
          </div>

          <div className="phone-only stack">
            {rows.map((r, i) => (
              <Card key={`${r.at}-${i}`}>
                <p>
                  <b>{actionLabel(r.action)}</b>
                  {r.business ? ` · ${r.business}` : ""}
                </p>
                <p className="tiny muted adm-wrap">
                  {day(r.at)} {time(r.at)} · {r.admin_email}
                </p>
                {r.detail && <p className="tiny adm-wrap">{r.detail}</p>}
              </Card>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
